/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiSsoProviderCompanyMappingFromJSON(json) {
    return StreemApiSsoProviderCompanyMappingFromJSONTyped(json, false);
}
export function StreemApiSsoProviderCompanyMappingFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'ssoProviderCode': !exists(json, 'sso_provider_code') ? undefined : json['sso_provider_code'],
        'companyCode': !exists(json, 'company_code') ? undefined : json['company_code'],
        'automaticRegistration': !exists(json, 'automatic_registration') ? undefined : json['automatic_registration'],
    };
}
export function StreemApiSsoProviderCompanyMappingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sso_provider_code': value.ssoProviderCode,
        'company_code': value.companyCode,
        'automatic_registration': value.automaticRegistration,
    };
}
//# sourceMappingURL=StreemApiSsoProviderCompanyMapping.js.map